import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';

import './DiscoverActionButton.scss';

export default function DiscoverActionButton({
    label,
    icon,
    onClick,
    className = '',
    ariaLabel = '',
}) {
    return (
        <button
            type="button"
            className={classNames('discover-action-button', className)}
            onClick={onClick}
            aria-label={ariaLabel || label}
        >
            <span className="discover-action-button__plus" aria-hidden="true" />
            <span className="discover-action-button__icon" aria-hidden="true">
                {icon}
            </span>
            <span className="discover-action-button__label">
                {label}
            </span>
        </button>
    );
}

DiscoverActionButton.propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
    ariaLabel: PropTypes.string,
};
